<template>
  <div
    class="draggable"
    :style="{ top: position.y + 'px', left: position.x + 'px' }"
    @mousedown="startDrag"
    @mouseup="stopDrag"
  >
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    elWidth: {
      type: Number,
      default: 100
    },
    elHeight: {
      type: Number,
      default: 20
    }
  },
  data() {
    return {
      isDragging: false,
      position: { x: 1000, y: 5 },
      offset: { x: 0, y: 0 },
    };
  },
  methods: {
    startDrag(event) {
      this.isDragging = true;
      this.offset.x = event.clientX - this.position.x;
      this.offset.y = event.clientY - this.position.y;
      this.$emit('startDrag')
      document.addEventListener('mousemove', (el) => {
         this.drag(el)
      })
    },
    drag(event) {
      if (this.isDragging) {
        this.position.x = event.clientX - this.offset.x;
        this.position.y = event.clientY - this.offset.y;
        if (this.position.y <= 0) {
          this.position.y = 0
        } else if (this.position.y >= document.documentElement.clientHeight - this.elHeight) {
          this.position.y = document.documentElement.clientHeight - this.elHeight
        }
        if (this.position.x <= 0) {
          this.position.x = 0
        } else if (this.position.x >= document.documentElement.clientWidth - this.elWidth) {
          this.position.x = document.documentElement.clientWidth - this.elWidth
        }
      }
    },
    stopDrag() {
      this.isDragging = false;
      this.$emit('stopDrag')
    },
  },
};
</script>

<style>
.draggable {
  position: absolute;
  cursor: move;
  z-index: 10;
}
</style>